import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import TextField from '../components/TextField';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from "../components/common/react-notifications";
import {isEqual, find} from 'lodash';
import Switch from 'react-switch';
import {required} from "../helpers/Validators";
import FieldError from "../components/FieldError";
import {store} from "../AppRenderer";
import Select from "react-select";
import Api from "../services/Api";

class TagManageForm extends React.Component {
  constructor(props) {
    super(props);
    this.tokenOptions = store.getState().general.tokens.map(token => ({
      label: token.symbol, value: token.symbol
    }));
  }

  addTag = async values => {
    const {t, afterSubmit} = this.props;
    const {name, tokens, enabled, fa, en} = values;
    try {
      await Api.invoke(
        'POST',
        '/v2/admin-ui/tags',
        {
          name: String(name).toUpperCase(),
          tokens: tokens.map(item => item.value),
          labels: [
            {language: "fa", value: fa},
            {language: "en", value: en},
          ],
          enabled,
        },
      );
      NotificationManager.success(t('New tag added successfully'), t('Message'));
      afterSubmit();
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updateTag = async values => {
    const {t, tag, afterSubmit} = this.props;
    const {name, tokens, enabled, fa, en} = values;
    const newValues = {
      name: String(name).toUpperCase(),
      tokens: tokens.map(item => item.value),
      labels: [
        {language: "fa", value: fa},
        {language: "en", value: en},
      ],
      enabled,
    };
    try {
      await Api.invoke(
        'PATCH',
        `/v2/admin-ui/tags/${tag.id}`,
        newValues
      );
      NotificationManager.success(t('Tag {{name}} updated successfully', {name}), t('Message'));
      afterSubmit();
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
      closeMenuOnSelect={false}
    />
  );

  render() {
    const {t, tag} = this.props;
    return(
      <FinalForm
        initialValues={{
          name: tag ? tag.name : undefined,
          tokens: tag ? tag.tokens.map(item => ({label: item, value: item})) : undefined,
          enabled: tag ? tag.enabled : false,
          fa: tag ? find(tag.labels, {language: 'fa'}).value : undefined,
          en: tag ? find(tag.labels, {language: 'en'}).value : undefined,
        }}
        onSubmit={tag ? this.updateTag : this.addTag}
        render={({handleSubmit, submitting, hasValidationErrors, values, initialValues}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-2">
                <Col>
                  <TextField
                    item={{
                      name: 'name',
                      i18n: t('Tag Name'),
                      type: 'text',
                      required: true,
                    }}
                  />
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col>
                  <TextField item={{
                    name: 'fa',
                    i18n: t('Farsi Name'),
                    type: 'text',
                    required: true,
                  }}/>
                </Col>
                <Col>
                  <TextField item={{
                    name: 'en',
                    i18n: t('English Name'),
                    type: 'text',
                    required: true,
                  }}/>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col>
                  <span>
                   {t('tokens')}
                  </span>
                  <Field
                    name="tokens"
                    component={this.ReactSelectAdapter}
                    options={this.tokenOptions}
                    validate={required}
                  />
                  <FieldError name='tokens' />
                </Col>
              </Row>
              <Field name='enabled'>
                {({input}) => (
                  <Row className="align-items-center mb-3">
                    <Switch
                      className="mx-3 ltr"
                      onChange={enabled => {input.onChange(enabled);}}
                      checked={input.value}
                      height={24}
                      width={45}
                    />
                    <span className={`mx-2 ${input.value ? 'text-success' : 'text-danger'}`}>
                      {t('Status')} {input.value ? t('Enabled') : t('Disabled')}
                    </span>
                  </Row>
                )}
              </Field>
              <Row className='mt-5'>
                <Col>
                  <LoaderButton
                    color="success"
                    className="text-center"
                    loading={submitting}
                    onClick={handleSubmit}
                    style={{minWidth: '100px'}}
                    disabled={hasValidationErrors || submitting || isEqual(values, initialValues)}>
                    {tag ? t('Update') : t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(TagManageForm);
